export enum LaboratoryExamsFlowKeys {
  COVERAGE = 'COVERAGE',
  EXAMS = 'EXAMS',
  SCHEDULES = 'SCHEDULES',
}
